export default "__VITE_ASSET__d66fa977__"